export default __webpack_public_path__ + "static/media/animal05.82b9b68f.png";